var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 11,
    style: {
      fill: "rgb(69.803922%,13.333333%,20.392157%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 300,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0 450.106534 L 7410 450.106534 M 7410 1049.786932 L 0 1049.786932 M 0 1649.46733 L 7410 1649.46733 M 7410 2250.53267 L 0 2250.53267 M 0 2850.213068 L 7410 2850.213068 M 7410 3449.893466 L 0 3449.893466 ",
    transform: "matrix(0.00296896,0,0,0.00282051,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(23.529412%,23.137255%,43.137255%)",
      fillOpacity: 1
    },
    d: "M 0 0 L 8.800781 0 L 8.800781 5.921875 L 0 5.921875 Z M 0 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0.734375 0.253906 L 0.941406 0.867188 L 0.394531 0.488281 L 1.070312 0.488281 L 0.523438 0.867188 Z M 0.734375 0.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0.734375 1.4375 L 0.941406 2.050781 L 0.394531 1.671875 L 1.070312 1.671875 L 0.523438 2.050781 Z M 0.734375 1.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0.734375 2.625 L 0.941406 3.234375 L 0.394531 2.855469 L 1.070312 2.855469 L 0.523438 3.234375 Z M 0.734375 2.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0.734375 3.808594 L 0.941406 4.421875 L 0.394531 4.042969 L 1.070312 4.042969 L 0.523438 4.421875 Z M 0.734375 3.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 0.734375 4.992188 L 0.941406 5.605469 L 0.394531 5.226562 L 1.070312 5.226562 L 0.523438 5.605469 Z M 0.734375 4.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.464844 0.847656 L 1.675781 1.457031 L 1.128906 1.078125 L 1.804688 1.078125 L 1.257812 1.457031 Z M 1.464844 0.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.464844 2.03125 L 1.675781 2.644531 L 1.128906 2.265625 L 1.804688 2.265625 L 1.257812 2.644531 Z M 1.464844 2.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.464844 3.214844 L 1.675781 3.828125 L 1.128906 3.449219 L 1.804688 3.449219 L 1.257812 3.828125 Z M 1.464844 3.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 1.464844 4.398438 L 1.675781 5.011719 L 1.128906 4.632812 L 1.804688 4.632812 L 1.257812 5.011719 Z M 1.464844 4.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.199219 0.253906 L 2.410156 0.867188 L 1.859375 0.488281 L 2.539062 0.488281 L 1.992188 0.867188 Z M 2.199219 0.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.199219 1.4375 L 2.410156 2.050781 L 1.859375 1.671875 L 2.539062 1.671875 L 1.992188 2.050781 Z M 2.199219 1.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.199219 2.625 L 2.410156 3.234375 L 1.859375 2.855469 L 2.539062 2.855469 L 1.992188 3.234375 Z M 2.199219 2.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.199219 3.808594 L 2.410156 4.421875 L 1.859375 4.042969 L 2.539062 4.042969 L 1.992188 4.421875 Z M 2.199219 3.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.199219 4.992188 L 2.410156 5.605469 L 1.859375 5.226562 L 2.539062 5.226562 L 1.992188 5.605469 Z M 2.199219 4.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.933594 0.847656 L 3.144531 1.457031 L 2.59375 1.078125 L 3.273438 1.078125 L 2.722656 1.457031 Z M 2.933594 0.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.933594 2.03125 L 3.144531 2.644531 L 2.59375 2.265625 L 3.273438 2.265625 L 2.722656 2.644531 Z M 2.933594 2.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.933594 3.214844 L 3.144531 3.828125 L 2.59375 3.449219 L 3.273438 3.449219 L 2.722656 3.828125 Z M 2.933594 3.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 2.933594 4.398438 L 3.144531 5.011719 L 2.59375 4.632812 L 3.273438 4.632812 L 2.722656 5.011719 Z M 2.933594 4.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.667969 0.253906 L 3.875 0.867188 L 3.328125 0.488281 L 4.003906 0.488281 L 3.457031 0.867188 Z M 3.667969 0.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.667969 1.4375 L 3.875 2.050781 L 3.328125 1.671875 L 4.003906 1.671875 L 3.457031 2.050781 Z M 3.667969 1.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.667969 2.625 L 3.875 3.234375 L 3.328125 2.855469 L 4.003906 2.855469 L 3.457031 3.234375 Z M 3.667969 2.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.667969 3.808594 L 3.875 4.421875 L 3.328125 4.042969 L 4.003906 4.042969 L 3.457031 4.421875 Z M 3.667969 3.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 3.667969 4.992188 L 3.875 5.605469 L 3.328125 5.226562 L 4.003906 5.226562 L 3.457031 5.605469 Z M 3.667969 4.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.398438 0.847656 L 4.609375 1.457031 L 4.0625 1.078125 L 4.738281 1.078125 L 4.191406 1.457031 Z M 4.398438 0.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.398438 2.03125 L 4.609375 2.644531 L 4.0625 2.265625 L 4.738281 2.265625 L 4.191406 2.644531 Z M 4.398438 2.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.398438 3.214844 L 4.609375 3.828125 L 4.0625 3.449219 L 4.738281 3.449219 L 4.191406 3.828125 Z M 4.398438 3.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 4.398438 4.398438 L 4.609375 5.011719 L 4.0625 4.632812 L 4.738281 4.632812 L 4.191406 5.011719 Z M 4.398438 4.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.132812 0.253906 L 5.34375 0.867188 L 4.792969 0.488281 L 5.472656 0.488281 L 4.925781 0.867188 Z M 5.132812 0.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.132812 1.4375 L 5.34375 2.050781 L 4.792969 1.671875 L 5.472656 1.671875 L 4.925781 2.050781 Z M 5.132812 1.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.132812 2.625 L 5.34375 3.234375 L 4.792969 2.855469 L 5.472656 2.855469 L 4.925781 3.234375 Z M 5.132812 2.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.132812 3.808594 L 5.34375 4.421875 L 4.792969 4.042969 L 5.472656 4.042969 L 4.925781 4.421875 Z M 5.132812 3.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.132812 4.992188 L 5.34375 5.605469 L 4.792969 5.226562 L 5.472656 5.226562 L 4.925781 5.605469 Z M 5.132812 4.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.867188 0.847656 L 6.074219 1.457031 L 5.527344 1.078125 L 6.207031 1.078125 L 5.65625 1.457031 Z M 5.867188 0.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.867188 2.03125 L 6.074219 2.644531 L 5.527344 2.265625 L 6.207031 2.265625 L 5.65625 2.644531 Z M 5.867188 2.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.867188 3.214844 L 6.074219 3.828125 L 5.527344 3.449219 L 6.207031 3.449219 L 5.65625 3.828125 Z M 5.867188 3.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.867188 4.398438 L 6.074219 5.011719 L 5.527344 4.632812 L 6.207031 4.632812 L 5.65625 5.011719 Z M 5.867188 4.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.601562 0.253906 L 6.808594 0.867188 L 6.261719 0.488281 L 6.9375 0.488281 L 6.390625 0.867188 Z M 6.601562 0.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.601562 1.4375 L 6.808594 2.050781 L 6.261719 1.671875 L 6.9375 1.671875 L 6.390625 2.050781 Z M 6.601562 1.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.601562 2.625 L 6.808594 3.234375 L 6.261719 2.855469 L 6.9375 2.855469 L 6.390625 3.234375 Z M 6.601562 2.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.601562 3.808594 L 6.808594 4.421875 L 6.261719 4.042969 L 6.9375 4.042969 L 6.390625 4.421875 Z M 6.601562 3.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 6.601562 4.992188 L 6.808594 5.605469 L 6.261719 5.226562 L 6.9375 5.226562 L 6.390625 5.605469 Z M 6.601562 4.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.332031 0.847656 L 7.542969 1.457031 L 6.996094 1.078125 L 7.671875 1.078125 L 7.125 1.457031 Z M 7.332031 0.847656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.332031 2.03125 L 7.542969 2.644531 L 6.996094 2.265625 L 7.671875 2.265625 L 7.125 2.644531 Z M 7.332031 2.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.332031 3.214844 L 7.542969 3.828125 L 6.996094 3.449219 L 7.671875 3.449219 L 7.125 3.828125 Z M 7.332031 3.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.332031 4.398438 L 7.542969 5.011719 L 6.996094 4.632812 L 7.671875 4.632812 L 7.125 5.011719 Z M 7.332031 4.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.066406 0.253906 L 8.277344 0.867188 L 7.726562 0.488281 L 8.40625 0.488281 L 7.855469 0.867188 Z M 8.066406 0.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.066406 1.4375 L 8.277344 2.050781 L 7.726562 1.671875 L 8.40625 1.671875 L 7.855469 2.050781 Z M 8.066406 1.4375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.066406 2.625 L 8.277344 3.234375 L 7.726562 2.855469 L 8.40625 2.855469 L 7.855469 3.234375 Z M 8.066406 2.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.066406 3.808594 L 8.277344 4.421875 L 7.726562 4.042969 L 8.40625 4.042969 L 7.855469 4.421875 Z M 8.066406 3.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 8.066406 4.992188 L 8.277344 5.605469 L 7.726562 5.226562 L 8.40625 5.226562 L 7.855469 5.605469 Z M 8.066406 4.992188 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/US_flag.8e38c60661ce635b47c61a6b90ad8779.svg";
export { ForwardRef as ReactComponent };